module.exports = __webpack_public_path__ + "img/title_pic.61f390ff.jpg";